/** https://docs.tsafe.dev/typeguard */
function typeGuard(value, isMatched) {
    return isMatched;
}

export { typeGuard };
//# sourceMappingURL=typeGuard.mjs.map
